import { waitForAllReturnWhenError } from '@confluence/query-preloader-tools/entry-points/waitForAllReturnWhenError';
import { query } from '@confluence/query-preloader-tools/entry-points/graphql';
import { preloadSpacesList } from '@confluence/space-utils/entry-points/preloadSpacesList';

import { HomeLeftPanelAdministrationQuery } from '../LeftPanel/HomeLeftPanelAdministrationQuery.graphql';

export const preloadHomeNavigation = ({
	isLoggedIn,
	isLicensed,
}: {
	isLoggedIn: boolean;
	isLicensed: boolean;
}) => {
	// Spaces list and Administration section shown in the left navigation
	return waitForAllReturnWhenError([
		preloadSpacesList({ isLicensed }),
		preloadLeftPanelAdministrationQuery({ isLoggedIn }),
	]);
};

const preloadLeftPanelAdministrationQuery = ({ isLoggedIn }: { isLoggedIn: boolean }) => {
	const queryOptions = {
		query: HomeLeftPanelAdministrationQuery,
		skip: !isLoggedIn,
	};
	/* @ts-expect-error -- http://go/cfe-use-relay-artifacts */
	return query(queryOptions);
};
